import React from 'react';
import styles from './tagList.module.scss';

export type Tag = {
    id: number;
    tagKey: string;
    name: string;
    count?: number;
    isActive?: boolean;
    onTagClick?: Function;
    showCount?: boolean;
};

const TagComponent = ({ id, tagKey, name, count, isActive, onTagClick, showCount }: Tag) => {
    const handleTagClick = () => {
        onTagClick(id);
    };

    return (
        <div
            className={isActive ? `${styles.active} ${styles.tag}` : `${styles.tag}`}
            key={`${tagKey}-${id}`}
            data-tag-id={id}
            onClick={handleTagClick}
        >
            {name} {showCount && <span className={styles.count}>({count})</span>}
        </div>
    );
};

export default TagComponent;
